import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  leftIcon?: React.ReactNode;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  isLoading = false,
  leftIcon,
  className = '',
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'btn-base';
  const variants = {
    primary: 'bg-fd-teal text-white hover:bg-[#17A39B] focus:ring-fd-teal shadow-sm hover:shadow active:scale-[0.98]',
    secondary: 'bg-fd-dark text-white hover:bg-[#2D3E50] focus:ring-fd-dark shadow-sm hover:shadow active:scale-[0.98]',
    outline: 'border-2 border-gray-300 bg-transparent hover:bg-gray-50 hover:border-gray-400 text-gray-700 focus:ring-gray-500 active:scale-[0.98]',
    ghost: 'bg-transparent hover:bg-gray-100 text-gray-700 focus:ring-gray-500 active:scale-[0.98]'
  };
  const sizes = {
    sm: 'h-9 px-3 text-sm gap-1.5',
    md: 'h-10 px-4 py-2 gap-2',
    lg: 'h-12 px-6 text-base gap-2'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-238">
      {isLoading && <Loader2 className="w-4 h-4 animate-spin" data-id="element-239" />}
      {!isLoading && leftIcon && <span className="flex-shrink-0" data-id="element-240">{leftIcon}</span>}
      <span data-id="element-241">{children}</span>
    </button>;
}